import React from 'react';
import { Download, ShoppingBag } from 'lucide-react';

const PurchasesTab = ({ userPurchases }) => {
  return (
    <div data-testid="purchases-tab">
      <h2 className="heading-2" style={{ marginBottom: '0.5rem' }}>Mes Achats</h2>
      <p className="body-small" style={{ color: 'var(--text-muted)', marginBottom: '2rem' }}>
        Retrouvez l'historique de vos achats et formules souscrites.
      </p>

      {userPurchases.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {userPurchases.map((purchase, idx) => {
            const formula = (purchase.metadata?.formula || '').toUpperCase();
            const formulaColors = {
              BRONZE: { bg: '#f5e6d3', border: '#d4a574', text: '#8B6914' },
              SILVER: { bg: '#f0e6f6', border: '#9b59b6', text: '#8e44ad' },
              GOLD: { bg: '#fdf6e3', border: '#d4af37', text: '#b8960c' }
            };
            const colors = formulaColors[formula] || { bg: '#f0f9ff', border: '#bae6fd', text: '#0369a1' };
            return (
              <div key={idx} className="card" style={{ padding: '1.25rem', borderLeft: `4px solid ${colors.border}` }} data-testid={`purchase-${idx}`}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
                      <span style={{
                        padding: '0.25rem 0.75rem', borderRadius: '1rem', fontSize: '0.7rem',
                        fontWeight: 700, letterSpacing: '0.05em',
                        background: colors.bg, color: colors.text, border: `1px solid ${colors.border}`
                      }}>
                        {formula || 'FORMULE'}
                      </span>
                      <span style={{
                        padding: '0.2rem 0.6rem', borderRadius: '1rem', fontSize: '0.65rem', fontWeight: 600,
                        background: purchase.status === 'completed' ? '#dcfce7' : purchase.status === 'pending' ? '#fef3c7' : '#fef2f2',
                        color: purchase.status === 'completed' ? '#166534' : purchase.status === 'pending' ? '#92400e' : '#dc2626'
                      }}>
                        {purchase.status === 'completed' ? 'Payé' : purchase.status === 'pending' ? 'En attente' : 'Annulé'}
                      </span>
                      {purchase.paymentMethod && purchase.paymentMethod !== 'stripe' && (
                        <span style={{
                          padding: '0.2rem 0.6rem', borderRadius: '1rem', fontSize: '0.65rem', fontWeight: 600,
                          background: '#e0e7ff', color: '#3730a3'
                        }}>
                          {purchase.paymentMethod === 'virement' ? 'Virement bancaire' : purchase.paymentMethod === 'manual' ? 'Manuel' : purchase.paymentMethod}
                        </span>
                      )}
                    </div>
                    <h3 style={{ fontWeight: 600, fontSize: '1rem', marginBottom: '0.25rem' }}>
                      {purchase.metadata?.program_name || purchase.programId || 'Formation'}
                    </h3>
                    <p className="caption" style={{ color: 'var(--text-muted)' }}>
                      {purchase.created_at ? new Date(purchase.created_at).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }) : '—'}
                    </p>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: '1.5rem', fontWeight: 700, color: colors.text }}>
                      {purchase.amount ? `${purchase.amount}€` : '—'}
                    </div>
                    {purchase.amountPaid != null && purchase.amount > 0 && (
                      <p className="caption" style={{ color: purchase.amountPaid >= purchase.amount ? '#166534' : '#92400e', fontWeight: 600 }}>
                        {purchase.amountPaid >= purchase.amount ? 'Soldé' : `${purchase.amountPaid}€ / ${purchase.amount}€`}
                      </p>
                    )}
                    {!purchase.installments && purchase.amount > 0 && (
                      <p className="caption" style={{ color: 'var(--text-muted)' }}>
                        ou 3x {Math.round(purchase.amount / 3)}€
                      </p>
                    )}
                  </div>
                </div>
                {/* Échéancier */}
                {purchase.installments && purchase.installments.length > 0 && (
                  <div style={{ marginTop: '1rem', padding: '0.75rem', background: 'var(--bg-card-alt, #f8fafc)', borderRadius: '0.5rem' }}>
                    <p style={{ fontSize: '0.75rem', fontWeight: 700, marginBottom: '0.5rem', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                      Échéancier de paiement
                    </p>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
                      {purchase.installments.map((inst, i) => (
                        <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.35rem 0.5rem', borderRadius: '0.25rem', background: inst.status === 'paid' ? '#f0fdf4' : '#fffbeb' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <span style={{
                              width: '8px', height: '8px', borderRadius: '50%', display: 'inline-block',
                              background: inst.status === 'paid' ? '#22c55e' : '#f59e0b'
                            }} />
                            <span style={{ fontSize: '0.8rem' }}>
                              Versement {i + 1}
                            </span>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>
                              {new Date(inst.date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' })}
                            </span>
                            <span style={{ fontSize: '0.8rem', fontWeight: 600 }}>{inst.amount}€</span>
                            <span style={{
                              padding: '0.1rem 0.4rem', borderRadius: '0.25rem', fontSize: '0.65rem', fontWeight: 600,
                              background: inst.status === 'paid' ? '#dcfce7' : '#fef3c7',
                              color: inst.status === 'paid' ? '#166534' : '#92400e'
                            }}>
                              {inst.status === 'paid' ? 'Payé' : 'À venir'}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                    {/* Progress bar */}
                    <div style={{ marginTop: '0.5rem', background: '#e5e7eb', borderRadius: '1rem', height: '6px', overflow: 'hidden' }}>
                      <div style={{
                        width: `${Math.round((purchase.amountPaid / purchase.amount) * 100)}%`,
                        background: 'linear-gradient(90deg, #22c55e, #16a34a)',
                        height: '100%', borderRadius: '1rem', transition: 'width 0.5s ease'
                      }} />
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="card" style={{ padding: '3rem', textAlign: 'center' }}>
          <ShoppingBag size={48} style={{ color: 'var(--text-muted)', margin: '0 auto 1rem', opacity: 0.4 }} />
          <h3 className="heading-3" style={{ marginBottom: '0.5rem' }}>Aucun achat pour le moment</h3>
          <p className="body-small" style={{ color: 'var(--text-muted)', marginBottom: '1.5rem' }}>
            Découvrez nos formations et choisissez la formule qui vous convient.
          </p>
          <button onClick={() => window.location.href = '/programs'} className="btn-primary" style={{ margin: '0 auto' }} data-testid="go-to-programs">
            Voir les formations
          </button>
        </div>
      )}
    </div>
  );
};

export default PurchasesTab;
